import { render } from "./CustomOrder.vue?vue&type=template&id=192af85c"
import script from "./CustomOrder.vue?vue&type=script&lang=js"
export * from "./CustomOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__